import {
  closestCorners,
  defaultDropAnimationSideEffects,
  DndContext,
  DragOverlay,
  type DropAnimation, // Add this import
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import type { ReactNode } from 'react';

interface DndProviderProps {
  onDragStart?: (event: any) => void;
  onDragEnd: (event: any) => void;
  onDragCancel?: () => void;
  overlayContent?: ReactNode;
  children: ReactNode;
  dropAnimation?: DropAnimation | null; // Add this prop
}
const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.5',
      },
    },
  }),
};
const VnTableDndProvider: React.FC<DndProviderProps> = ({
  onDragStart,
  onDragEnd,
  onDragCancel,
  overlayContent,
  children,
  dropAnimation, // Destructure here
}) => {
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCorners}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
    >
      {children}
      {/* Pass the dropAnimation prop here */}
      <DragOverlay dropAnimation={null}>{overlayContent ?? null}</DragOverlay>
    </DndContext>
  );
};

export default VnTableDndProvider;
